import { useId } from 'react';

export const IconFacebookFooter = ({
  width = 40,
  height = 40,
  color = 'var(--violet)',
}) => {
  const clipId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='20' fill={color} />
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M30 20c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 4.84 3.44 8.87 8 9.8V23h-2v-3h2v-2.5c0-1.93 1.57-3.5 3.5-3.5H24v3h-2c-.55 0-1 .45-1 1v2.5h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95Z'
          fill='#FAFAFC'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect x='10' y='10' width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
